import React from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Reusable Breadcrumb Component for Admission modules.
 * Ensures consistent navigation and styling across forms, dashboards, and registrations.
 * 
 * @param {Array} items - Array of objects { label, path, state }
 * @param {String} className - Additional CSS classes
 */
const AdmissionBreadcrumb = ({ history, items = [], className = "mt-4" }) => {
  return (
    <ul className={`af-breadcrumb ${className}`}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        
        // Render as active text if it's the last item OR if it has no path
        if (isLast || !item.path) {
          return (
            <li key={index} className="af-bc-item active">
              {item.label}
            </li>
          );
        }

        // Render as a clickable link
        return (
          <li key={index} className="af-bc-item">
            <a 
              href={`#${item.path}`} 
              onClick={(e) => { 
                e.preventDefault(); 
                history.push(item.path, item.state); 
              }}
            >
              {item.label}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default withRouter(AdmissionBreadcrumb);
